import { render, staticRenderFns } from "./PreAssessment.vue?vue&type=template&id=7611dad9&scoped=true"
import script from "./PreAssessment.vue?vue&type=script&lang=js"
export * from "./PreAssessment.vue?vue&type=script&lang=js"
import style0 from "./PreAssessment.vue?vue&type=style&index=0&id=7611dad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7611dad9",
  null
  
)

export default component.exports